<template>
  <fieldset>
    <label
      v-if="label"
      class="my-2 block font-semibold leading-6 text-gray-900 md:font-bold"
    >
      {{ label }}
    </label>

    <div class="divide-y divide-gray-200">
      <FilterRadioButton
        v-for="option in options"
        :key="option.value"
        v-bind="{
          customSizeRadioButtonId,
          loading,
          option,
        }"
        @changed-filter="$emit('changed-filter')"
      />

      <div v-if="!!sizeStore.sizeOptions.length" class="py-3">
        <FilterCustomSizeRadioButton
          v-bind="{
            customSizeRadioButtonId,
            loading,
          }"
          @update:model-value="$emit('changed-filter')"
        />
      </div>
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { PropType } from 'vue';
import type { SelectorOption } from '@/types/Configurator/SelectorOption';
import FilterRadioButton from '@/pages/ProductPage/partials/ProductFilters/FilterRadioButton.vue';
import { useSizeStore } from '@/stores/Configurator/SizeStore.ts';
import FilterCustomSizeRadioButton from '@/pages/ProductPage/partials/ProductFilters/FilterCustomSizeRadioButton.vue';

defineEmits(['changed-filter']);

defineProps({
  label: {
    type: String,
    required: false,
    default: undefined,
  },

  options: {
    type: Array as PropType<SelectorOption[]>,
    required: true,
  },

  customSizeRadioButtonId: {
    type: String,
    required: false,
    default: 'custom-size-radio-button-desktop',
  },

  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const sizeStore = useSizeStore();
</script>
